import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { EmailsGridPage } from 'app/pages/EmailsGridPage';
import { CONFIGURE_RESOURCE_STATIC_VALUE_MESSAGES } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useStaticContentValueMessagesPage } from './hooks/useStaticContentValueMessagesPage';

const StaticContentConfigurationPage = () => {
  const { breadcrumbsList, hasDealer } = useStaticContentValueMessagesPage();

  return (
    <>
      <Helmet>
        <title>Static Content - Value Messages</title>
        <meta
          name="description"
          content="Configure static content value messages for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Static Content - Value Messages"
        contentVariant="centered"
      >
        <EmailsGridPage
          embedded
          hideGenerateEmailTemplateDropdown
          defaultGeneratedTypeStatic
          emailTemplatesGridPreset="staticValueMessages"
          emailTemplateBreadcrumbOrigin={{
            label: 'Static Content - Value Messages',
            path: '/configure-static-content',
          }}
        />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  StaticContentConfigurationPage,
  CONFIGURE_RESOURCE_STATIC_VALUE_MESSAGES,
);
